import { Link } from '@/core/i18n/navigation';
import type { Crumb } from '@/lib/seo';

export function Breadcrumb({
  items,
  label = 'Breadcrumb',
}: {
  items: Crumb[];
  label?: string;
}) {
  return (
    <nav className="crt-breadcrumb" aria-label={label}>
      <ol>
        {items.map((item, index) => (
          <li
            key={item.href || item.label}
            className={
              index === items.length - 1 ? 'crt-crumb-current' : undefined
            }
          >
            {index > 0 && <span aria-hidden="true">/ </span>}
            {index === items.length - 1 ? (
              <span aria-current="page">{item.label}</span>
            ) : item.href ? (
              <Link href={item.href}>{item.label}</Link>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
